import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';

// jwt auth
const JwtAuthLogin = Loadable(lazy(() => import('pages/auth/jwt/login')));
// const JwtAuthEmailLogin = Loadable(lazy(() => import('pages/auth/jwt/email-login')));
const UserLogin = Loadable(lazy(() => import('pages/user-auth/login')));
const Verify = Loadable(lazy(() => import('pages/user-auth/verify')));
// const JwtAuthRegister = Loadable(lazy(() => import('pages/auth/jwt/register')));
const JwtAuthForgotPassword = Loadable(lazy(() => import('pages/auth/jwt/forgot-password')));
const JwtAuthResetPassword = Loadable(lazy(() => import('pages/auth/jwt/reset-password')));
const JwtAuthSetPassword = Loadable(lazy(() => import('pages/auth/jwt/set-password')));
// const JwtAuthCodeVerification = Loadable(lazy(() => import('pages/auth/jwt/code-verification')));
const JwtAuthCheckMail = Loadable(lazy(() => import('pages/auth/jwt/check-mail')));

// legal pages
const TermsAndConditions = Loadable(lazy(() => import('pages/legal/terms-and-conditions')));
const PrivacyPolicy = Loadable(lazy(() => import('pages/legal/privacy-policy')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/auth',
      children: [
        {
          path: 'login',
          children: [
            {
              index: true,
              element: <UserLogin />
            },
            {
              path: 'email',
              element: <JwtAuthLogin />
            }
          ]
        },
        {
          path: 'verify',
          element: <Verify />
        },
        {
          path: 'forgot-password',
          element: <JwtAuthForgotPassword />
        },
        {
          path: 'reset-password',
          element: <JwtAuthResetPassword />
        },
        {
          path: 'set-password',
          element: <JwtAuthSetPassword />
        },
        {
          path: 'check-mail',
          element: <JwtAuthCheckMail />
        }
      ]
    },
    // {
    //   path: 'register',
    //   element: <JwtAuthRegister />
    // },
    {
      path: 'terms-and-conditions',
      element: <TermsAndConditions />
    },
    {
      path: 'privacy-policy',
      element: <PrivacyPolicy />
    }
  ]
};

export default LoginRoutes;
